import { IdNameChildren, IdNamePair, InputOption } from "@/types/global";

export function setCheckboxItemsDisabled(
  checkboxItems: Array<IdNamePair> | undefined,
  checkedValues: Array<number>,
  maxItems: number | undefined,
) {
  if (!checkboxItems) {
    return [];
  }
  checkboxItems.forEach((checkboxItem) => {
    checkboxItem.IsDisabled =
      maxItems !== undefined &&
      checkedValues.length >= maxItems &&
      !checkedValues.includes(checkboxItem.Id);
  });
}

export function setNestedCheckboxItemsDisabled(
  checkboxItems: Array<IdNameChildren> | undefined,
  checkedValues: Array<number>,
  maxItems: number | undefined,
) {
  if (!checkboxItems) {
    return [];
  }
  checkboxItems.forEach((group) => {
    setCheckboxItemsDisabled(group.Children, checkedValues, maxItems);
  });
}

export function isCheckboxCheckAll(
  checkboxItems: Array<IdNameChildren> | Array<IdNamePair> | undefined,
  checkedValues: Array<number>,
  totalCheckboxItems: number,
) {
  return checkboxItems ? checkedValues.length === totalCheckboxItems : false;
}

export function isCheckboxCheckAllIndeterminate(
  checkboxItems: Array<IdNameChildren> | Array<IdNamePair> | undefined,
  checkedValues: Array<number>,
  totalCheckboxItems: number,
) {
  return checkboxItems
    ? checkedValues.length > 0 && checkedValues.length < totalCheckboxItems
    : false;
}

export function handleCheckboxCheckAllChange(
  checkboxItems: Array<IdNamePair> | undefined,
  checkedValues: Array<number>,
  checkAllStatus: boolean,
  totalCheckboxItems: number,
  maxItems: number | undefined,
) {
  if (!checkboxItems) {
    return { checkedValues: [], isCheckAllIndeterminate: false };
  }
  if (!checkAllStatus && checkedValues.length > 0) {
    checkedValues = [];
  } else if (checkAllStatus && checkedValues.length < totalCheckboxItems) {
    let allCheckedItems: Array<number> = [];
    checkboxItems.forEach((item) => {
      allCheckedItems.push(item.Id);
    });
    if (maxItems !== undefined) {
      allCheckedItems = allCheckedItems.slice(0, maxItems);
    }
    checkedValues = allCheckedItems;
  }
  return { checkedValues: checkedValues, isCheckAllIndeterminate: false };
}

export function handleNestedCheckboxCheckAllChange(
  checkboxItems: Array<IdNameChildren> | undefined,
  checkedValues: Array<number>,
  checkAllStatus: boolean,
  totalCheckboxItems: number,
  maxItems: number | undefined,
) {
  if (!checkboxItems) {
    return { checkedValues: [], isCheckAllIndeterminate: false };
  }
  if (!checkAllStatus && checkedValues.length > 0) {
    checkedValues = [];
  } else if (checkAllStatus && checkedValues.length < totalCheckboxItems) {
    let allCheckedItems: Array<number> = [];
    checkboxItems.forEach((group) => {
      if (group.Children) {
        group.Children.forEach((item) => {
          allCheckedItems.push(item.Id);
        });
      }
    });
    if (maxItems !== undefined) {
      allCheckedItems = allCheckedItems.slice(0, maxItems);
    }
    checkedValues = allCheckedItems;
  }
  return { checkedValues: checkedValues, isCheckAllIndeterminate: false };
}

export function handleCheckboxSearch(
  checkboxItems: Array<InputOption> | undefined,
  searchedValue: string,
) {
  if (!checkboxItems) {
    return;
  }
  checkboxItems.forEach((item) => {
    item.IsVisible = searchedValue
      ? item.Name.toLowerCase().includes(searchedValue.toLowerCase())
      : true;
  });
}

export function handleNestedCheckboxSearch(
  checkboxItems: Array<IdNameChildren> | undefined,
  searchedValue: string,
) {
  if (!checkboxItems) {
    return checkboxItems;
  }
  checkboxItems.forEach((group) => {
    handleCheckboxSearch(group.Children, searchedValue);
  });
}
